/**
 * @documental
 * @export Placeholder
 * @name
 * Dropdown.Placeholder
 */

import { FC } from "react";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";
import styles from "./styles.module.scss";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `Dropdown` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.DropdownPlaceholder, "dropdown-placeholder"],
    testIdPrefix: "dropdown-placeholder",
  });

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <div className={styles.PlaceholderDropdown}>
        <Skeleton />
      </div>
    </InputContainerPlaceholder>
  );
};
